<template>
    <div class="pages assistant">
        <div class="f1">
            <div class="d1">
                经营助手是积木云提供的数字智能方案，是每一个企业的数据分析官。积木助手提供会员与营销层面上的智能分析，助力企业更敏感的完成数字经营
            </div>
            <div class="d2">
                <div class="text">
                    <p>
                         JOLEL 你好，欢迎登陆积木助手，本周本周新增 <span>8</span>件值得关注的会员事件与<span>3</span>件营销事件。快去分析吧～
                    </p>
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="f2">
            <p class="tit">
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                积木助手提供以下能力，快来体验吧～
            </p>
            <ul>
                <li>
                    <p><span>会员生命周期助手</span></p>
                    <p>积木云为企业提供贯彻会员全生命周期的数字化方案，深挖会员360度系统行为，帮助企业了解会员新增、留存、参与、活跃、流失的全流程LTV价值分析。</p>
                    <p @click="$router.push({name:'lifecycle'})"><el-button icon="el-icon-right" type="text">立即体验</el-button></p>
                </li>
                <li>
                    <p><span>全域营销助手</span></p>
                    <p>基于积木云的会员画像功能，企业可构建人群经营与场景经营的全域营销方案。基于用户偏好与运营活动实现数字化增长。</p>
                    <p @click="$router.push({name:'crowdMarketing'})"><el-button icon="el-icon-right" type="text">立即体验</el-button></p>
                </li>
                <li>
                    <p><span>积木云助手功能</span></p>
                    <p>积木云是积木创意旗下的数字化中台实施项目，立足消费者数字化增长领域，利用积木云代码能力整合企业业务信息系统，构建全域数字化运营体系，助力企业增长。快速了解积木云数字化能力吧～</p>
                    <p @click="$router.push({name:'useBook'})"><el-button icon="el-icon-right" type="text">立即体验</el-button></p>
                </li>
            </ul>
        </div>
        <div class="f3">
            <div class="title">
                <div class="t1">
                    <p>
                        <img class="log" src="../../assets/images/newIcon/vip_ai_icon.png" alt="">
                        积木助手
                        <span>最新更新时间为：2021.10.10 18:00:00</span>
                    </p>
                </div>
            </div>
            <ul>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            会员事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgvip_icon.png" alt="">
                    </div>
                    <div>本周新增<span>123</span>位新用户，其中 <span>x%</span>渠道来源数量最多。同比上周增长<span>x%</span>，快去激活会员吧～</div>
                    <div>
                        <p @click="goNewMemberGroup">设为会员组</p>
                        <p @click="goCrowdMarketing">会员经营</p>
                        <p @click="goCrowdDetails">查看详情</p>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            营销事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgyingxiao_icon.png" alt="">
                    </div>
                    <div>上上周新增会员的一周留存率为<span>x%</span>，低于上次</div>
                    <div class="btn1">
                        <el-button @click="goCrowdDetails" type="text">查看详情 >></el-button>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            会员事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgvip_icon.png" alt="">
                    </div>
                    <div>本周新增<span>123</span>位新用户，其中 <span>x%</span>渠道来源数量最多。同比上周增长<span>x%</span>，快去激活会员吧～</div>
                    <div>
                        <p @click="goNewMemberGroup">设为会员组</p>
                        <p @click="goScene">唤醒会员</p>
                        <p @click="goCrowdDetails">查看详情</p>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            营销事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgyingxiao_icon.png" alt="">
                    </div>
                    <div>上上周新增会员的一周留存率为<span>x%</span>，低于上次</div>
                    <div class="btn1">
                        <el-button @click="goCrowdDetails" type="text">查看详情 >></el-button>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            会员事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgvip_icon.png" alt="">
                    </div>
                    <div>本周新增<span>123</span>位新用户，其中 <span>x%</span>渠道来源数量最多。同比上周增长<span>x%</span>，快去激活会员吧～</div>
                    <div class="btn2">
                        <p @click="goCrowdMarketing">会员经营</p>
                        <p @click="goCrowdDetails">查看详情</p>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            营销事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgyingxiao_icon.png" alt="">
                    </div>
                    <div>上上周新增会员的一周留存率为<span>x%</span>，低于上次</div>
                    <div class="btn1">
                        <el-button @click="goCrowdDetails" type="text">查看详情 >></el-button>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            会员事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgvip_icon.png" alt="">
                    </div>
                    <div>本周新增<span>123</span>位新用户，其中 <span>x%</span>渠道来源数量最多。同比上周增长<span>x%</span>，快去激活会员吧～</div>
                    <div>
                        <p @click="goNewMemberGroup">设为会员组</p>
                        <p @click="goScene">唤醒会员</p>
                        <p @click="goCrowdDetails">查看详情</p>
                    </div>
                </li>
                <li>
                    <div>
                        <p>
                            <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                            营销事件
                        </p>
                        <img src="../../assets/images/newIcon/jimu_bgvip_icon.png" alt="">
                    </div>
                    <div>本周新增<span>123</span>位新用户，其中 <span>x%</span>渠道来源数量最多。同比上周增长<span>x%</span>，快去激活会员吧～</div>
                    <div>
                        <p @click="goNewMemberGroup">设为会员组</p>
                        <p @click="goScene">唤醒会员</p>
                        <p @click="goCrowdDetails">查看详情</p>
                    </div>
                </li>
                
            </ul>
        </div>
        <div class="f4">
            <ul>
                <li>
                    <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_vipthing_icon.png" alt="">
                                会员新增事件
                                <el-tooltip class="item" effect="dark" content="显示本周新会员增长数据及趋势分析" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <span>新增会员各渠道数据汇总</span>
                            </p>
                        </div>
                    </div>
                    <div class="text">本周合计新增：<span>100</span> ，上周合计新增：<span>50</span> 本周新增会员数量高/低于上周，其中<span>微信小程序</span>较为突出</div>
                    <div class="cans">
                        <div>
                            <p>19,999</p>
                            <p>微信小程序</p>
                        </div>
                        <div>
                            <p>19,999</p>
                            <p>移动端</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>抖音</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                    </div>
                    <div class="num">
                        <div>
                            <p class="t">本周</p>
                            <div class="c">
                                <div>
                                    <p>319 <span>人</span></p>
                                </div>
                                <div>
                                    <p>环比 <span class="red">
                                        5.9% <i class="el-icon-bottom"></i>
                                        </span>
                                    </p>    
                                    <p>同比 
                                        <span class="gru">
                                            5.9% <i class="el-icon-top"></i>
                                        </span>
                                    </p>    
                                </div>
                                
                            </div>
                        </div>
                        <div class="number">
                            <i></i>
                            <div>
                                <p>合计：<span>31,123</span>人</p>
                                <p>均值：<span>31,123</span>人</p>
                            </div>
                            
                        </div>
                    </div>
                    <div>
                        <div id="members"></div>
                    </div>
                </li>
                <li>
                    <div class="posi" @click="goScene">
                        <img src="../../assets/images/newIcon/jimu_huanxing_icon.png" alt="">
                        唤醒会员
                    </div>
                    <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_viplose_icon.png" alt="">
                                会员流失事件
                                <el-tooltip class="item" effect="dark" content="显示本周新增流失会员数据及趋势，可设置唤醒计划。" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <span>新增会员各渠道数据汇总</span>
                            </p>
                        </div>
                    </div>
                    <div class="text">本周合计新增：<span>100</span> ，上周合计新增：<span>50</span> 本周新增会员数量高/低于上周，其中<span>微信小程序</span>较为突出</div>
                    <div class="cans">
                        <div>
                            <p>19,999</p>
                            <p>微信小程序</p>
                        </div>
                        <div>
                            <p>19,999</p>
                            <p>移动端</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>抖音</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                        <div>
                           <p>19,999</p>
                            <p>小红书</p>
                        </div>
                    </div>
                    <div class="num">
                        <div>
                            <p class="t">本周</p>
                            <div class="c">
                                <div>
                                    <p>319 <span>人</span></p>
                                </div>
                                <div>
                                    <p>环比 <span class="red">
                                        5.9% <i class="el-icon-bottom"></i>
                                        </span>
                                    </p>    
                                    <p>同比 
                                        <span class="gru">
                                            5.9% <i class="el-icon-top"></i>
                                        </span>
                                    </p>    
                                </div>
                                
                            </div>
                        </div>
                        <div class="number">
                            <i></i>
                            <div>
                                <p>合计：<span>31,123</span>人</p>
                                <p>均值：<span>31,123</span>人</p>
                            </div>
                            
                        </div>
                    </div>
                    <div>
                        <div id="Drain"></div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="f5">
            <ul>
                <li class="l1">
                    <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_vipmeet_icon.png" alt="">
                                会员访问事件
                                <el-tooltip class="item" effect="dark" content="一周内会员访问页面排行榜。访问下单率=访问人数/下单人数。访问支付率=访问人数/支付人数。下单支付率=下单人数/支付人数" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <span>会员访问页面数据汇总</span>
                            </p>
                        </div>
                    </div>
                    <div class="content">
                        <div>
                            <ul>
                                <li>
                                    <div>
                                        <p><img src="../../assets/images/newIcon/jimu_fangke_icon.png" alt=""></p>
                                        <p>访客</p>
                                    </div>
                                    
                                </li>
                                <li>
                                    <div>
                                        <p><img src="../../assets/images/newIcon/jimu_xiadan_icon.png" alt=""></p>
                                        <p>下单</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <p><img src="../../assets/images/newIcon/jimu_zhifu_icon.png" alt=""></p>
                                        <p>支付</p>
                                    </div>
                                    
                                </li>
                            </ul>
                            <div class="log1 img-log">
                                  <img src="../../assets/images/newIcon/jimu_lineshort_pc.png" class="c1" alt="">
                                  <span>访客-下单转化率10.00%</span>
                            </div>
                            <div class="log2 img-log">
                                <img src="../../assets/images/newIcon/jimu_lineshort_pc.png" class="c2" alt="">
                                <span>下单-支付转化率10.00%</span>
                            </div>
                            <div class="log3 img-log">
                                <img src="../../assets/images/newIcon/jimu_line_pc.png" class="c3" alt="">
                                <span>访客-支付转化率10.00%</span>
                            </div>
                        </div>
                        <div>
                            <el-table
                                :data="tableData"
                                :header-cell-style="{background:'#EEEEEE',fontSize:'12px',textAlign: 'center'}"
                                style="width: 90%"
                                :cell-style="{padding:'15px 0px',fontSize:'12px',textAlign: 'center'}"
                                >
                                <el-table-column
                                prop="name"
                                label="序号"
                                
                                min-width="20%">

                                </el-table-column>

                                <el-table-column
                                prop="number"
                                show-overflow-tooltip
                                label="页面标题"
                                min-width="20%">
                                </el-table-column>
                                <el-table-column
                                prop="xmember"
                                label="合计"
                                min-width="20%">
                                </el-table-column>
                            </el-table>
                            <p class="ts"> <i></i> 本周会员访问深度平均比上周高<span>2.5%</span></p>
                        </div>
                    </div>
                </li>
                <li class="l2">
                    <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_fenxi_icon.png" alt="">
                                渠道价值分析
                                <el-tooltip class="item" effect="dark" content="统计不同渠道的本月新增人数及渠道收入与活跃度。" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                                </el-tooltip>
                                <span>渠道对于平台的价值贡献排行</span>
                            </p>
                        </div>
                    </div>
                    <div class="ft">
                        在过去一个月中，<span>抖音</span>渠道的用户数最多，<span>小红书</span> 渠道的消费力最高，<span>快手</span>的活跃度最高
                    </div>
                    <el-table
                        :data="tableData2"
                          :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                        style="width: 100%"
                        :cell-style="{padding:'15px 0px',textAlign: 'center',fontSize:'12px'}"
                        >
                        <el-table-column
                        prop="name"
                        label="渠道"
                        show-overflow-tooltip
                        min-width="20%">

                        </el-table-column>

                        <el-table-column
                        prop="number"
                        label="渠道人数"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="渠道客单价"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="渠道价值"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="渠道活跃度"
                        min-width="20%">
                        </el-table-column>
                    </el-table>
                </li>
            </ul>
        </div>
        <div class="f6">
            <div class="title">
                <div class="t1">
                    <p>
                        <img class="log" src="../../assets/images/newIcon/jimu_wancheng_icon.png" alt="">
                        最近完成的运营事件
                        <span>运营事件数据复盘</span>
                    </p>
                </div>
            </div>
            <ul>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b" @click="$router.push({name:'crowdMarketing'})">
                                人群
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})">
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b b5" @click="$router.push({name:'sceneMarketing'})">
                                场景
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                        
                        
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})"> 
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b" @click="$router.push({name:'crowdMarketing'})">
                                人群
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                        
                        
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})">
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b" @click="$router.push({name:'crowdMarketing'})">
                                人群
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                        
                        
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})">
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b" @click="$router.push({name:'crowdMarketing'})">
                                人群
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                        
                        
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})">
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <div>
                            <span>
                                <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                24小时签到打卡
                            </span>
                            <span class="b" @click="$router.push({name:'crowdMarketing'})">
                                人群
                            </span>
                        </div>
                        <div>
                            <span>创建时间：</span>
                            <span class="c3">2021.07.09 16:53</span>
                        </div>
                        <div>
                            <span>状      态：</span>
                            <span class="c0091FF">完成</span>
                        </div>
                        <div class="jdt">
                            <span>目标完成率：</span>
                            <el-progress :percentage="20" ></el-progress>
                        </div>
                        
                        
                    </div>
                    <div class="d2">
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/jimu_yunying_icon.png" alt="">
                            去运营
                        </p>
                        <p @click="$router.push({name:'dataReport'})">
                            <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                            去复盘
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="f7">
            <ul>
                <li>
                     <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_use_icon.png" alt="">
                                活动用户后续留存
                                <span>参与活动的用户留存分析</span>
                            </p>
                        </div>
                    </div>
                    <div class="tabS">
                     <!-- :cell-style="{padding:'15px 0px'}" -->
                    <el-table
                        :data="tableData3"
                        :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                        style="width: 100%;"
                        :height='390'
                         border
                        :cell-style="cellStyle"
                        >
                        <el-table-column
                         v-for="(item,index) in headList"
                        :key="index"
                        :property="item.property"
                        :label="item.label"
                        min-width="60"
                        >
                        <template slot-scope="scope">
                            <p v-if="!scope.row[scope.column.property].isOk">
                                {{scope.row[scope.column.property]}}
                            </p>
                            <p v-if="scope.row[scope.column.property].isOk">
                                <span style="display:block;"> {{scope.row[scope.column.property].num}}人</span>
                                <span style="display:block;">{{scope.row[scope.column.property].f}}</span>
                            </p>
                        </template>
                        <!-- <template slot-scope="scope">{{scope.row}}</template> -->
                        </el-table-column>
                    </el-table>
                       
                    </div>
                </li>
                <li class="l2">
                     <div class="title">
                        <div class="t1">
                            <p>
                                <img class="log" src="../../assets/images/newIcon/jimu_huodong_icon.png" alt="">
                                活动敏感度
                                <span>活动价值统计</span>
                            </p>
                        </div>
                    </div>
                    <div class="ft">
                            <span>优惠券活动</span>带来的价值最高
                    </div>
                    <div class="cont">
                        
                        <div class="txt">
                            <p>
                                <span>2324</span>
                                <span>活动数量</span>
                            </p>
                            <p>
                                <span>14343</span>
                                <span>活动新增</span>
                            </p>
                            <p>
                                <span>100000</span>
                                <span>参与人数</span>
                            </p>
                            <p>
                                <span>3535262</span>
                                <span>活动价值</span>
                            </p>
                        </div>
                    </div>
                    <el-table
                        :data="tableData4"
                        :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                        style="width: 100%"
                        :cell-style="{padding:'15px 0px',textAlign: 'center',fontSize:'12px'}"
                        >
                        <el-table-column
                        prop="name"
                        label="活动名称"
                        show-overflow-tooltip
                        min-width="20%">

                        </el-table-column>

                        <el-table-column
                        prop="number"
                        label="新增人数"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="参与人数"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="活动价值"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="参与率"
                        min-width="20%">
                        </el-table-column>
                    </el-table>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            tableData: [{
                name: '1',
                number:"联合特价",
                xmember:"56.14%",
                }, {
                name: '2',
                number:"全场秒杀",
                xmember:"53.2%",
                }, {
                name: '3',
                number:"返券活动",
                xmember:"50.22%",
                }, {
                name: '4',
                number:"sk2满减sadf",
                xmember:"53.2%",
            }],
             tableData2: [{
                name: '小程序',
                number:"3000",
                xmember:"0",
                lmember:"0",
                labellv:"30%"
                }, {
                name: '小红书',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '移动端',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
            }],
             tableData4: [{
                name: '购买',
                number:"3000",
                xmember:"0",
                lmember:"0",
                labellv:"30%"
                }, {
                name: '优惠券活动',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '现场返利',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '会员发红包',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }],
            headList:[
                {
                    label: '总体',
                    property: 'expressName'
                },
                {
                    label: '总人数',
                    property: 'num'
                },
                {
                    label: '第1天',
                    property: 'day1'
                },
                {
                    label: '第2天',
                    property: 'day2'
                },
                {
                    label: '第3天',
                    property: 'day3'
                },
                {
                    label: '第4天',
                    property: 'day4'
                },
                {
                    label: '第5天',
                    property: 'day5'
                },
                {
                    label: '第6天',
                    property: 'day6'
                },
                {
                    label: '第7天',
                    property: 'day7'
                }
            ], 
             tableData3: [
                {
                expressName: '总体',
                num:"304人",
                day1:{num:"0",f:"97.97%",isOk:true},
                day2:{num:"0",f:"97.97%",isOk:true},
                day3:{num:"0",f:"97.97%",isOk:true},
                day4:{num:"0",f:"97.97%",isOk:true},
                day5:{num:"0",f:"97.97%",isOk:true},
                day6:{num:"0",f:"97.97%",isOk:true},
                day7:{num:"0",f:"97.97%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"28",f:"97.97%",isOk:true},
                day7:{num:"",f:"%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"28",f:"97.97%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"97.97%",isOk:true},
                day4:{num:"28",f:"97.97%",isOk:true},
                day5:{num:"0",f:"0%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"97.97%",isOk:true},
                day2:{num:"28",f:"97.97%",isOk:true},
                day3:{num:"28",f:"0%",isOk:true},
                day4:{num:"0",f:"0%",isOk:true},
                day5:{num:"0",f:"0%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                },
                 {
                expressName: '2021.06.28',
                num:"28人",
                day1:{num:"28",f:"0%",isOk:true},
                day2:{num:"28",f:"0%",isOk:true},
                day3:{num:"0",f:"0%",isOk:true},
                day4:{num:"0",f:"0%",isOk:true},
                day5:{num:"0",f:"0%",isOk:true},
                day6:{num:"0",f:"0%",isOk:true},
                day7:{num:"0",f:"0%",isOk:true},
                }
             ]
        }
    },
    mounted() {
        this.init();
        this.init2();
    },
    methods: {
        goNewMemberGroup(){
             this.$router.push({name:'newMemberGroup'})
        },
        goCrowdMarketing(){
             this.$router.push({name:'crowdMarketing'})
        },
        goCrowdDetails(){
            this.$router.push({name:'crowdDetails',query:{id:111}})
        },
        goScene(){
            this.$router.push({name:'sceneMarketing'});
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            // console.log(row[column.property],11111);
            let is=false;
            if (row[column.property].isOk && columnIndex>1) {
                if(row[column.property].num>0 || parseFloat(row[column.property].f)>0){
                   return `background:#90B5FF;color:#081BA9;fontSize:12px;textAlign:center`;
                }else{
                    return `fontSize:12px;textAlign:center;`
                }
            } else {
                return `fontSize:12px;textAlign:center;`
            }

        },
        init(){
            let d1=[
                {data:"6.21",name:'小程序',val:1000},
                {data:"6.22",name:'小程序',val:200},
                {data:"6.23",name:'小程序',val:400},
                {data:"6.24",name:'小程序',val:800},
            ]
            let d2=[
                {data:"6.21",name:'安卓端',val:300},
                {data:"6.22",name:'安卓端',val:600},
                {data:"6.23",name:'安卓端',val:100},
                {data:"6.24",name:'安卓端',val:300},
            ]
            let d3=[
                {data:"6.21",name:'iOS端',val:200},
                {data:"6.22",name:'iOS端',val:300},
                {data:"6.23",name:'iOS端',val:400},
                {data:"6.24",name:'iOS端',val:500},
            ]
            let d4=[
                {data:"6.21",name:'抖音',val:200},
                {data:"6.22",name:'抖音',val:400},
                {data:"6.23",name:'抖音',val:100},
                {data:"6.24",name:'抖音',val:200},
            ]
            let d5=[
                {data:"6.21",name:'小红书',val:300},
                {data:"6.22",name:'小红书',val:400},
                {data:"6.23",name:'小红书',val:200},
                {data:"6.24",name:'小红书',val:100},
            ]
            let data=[...d1,...d2,...d3,...d4,...d5];

            const chart = new this.$chart({
            container: 'members',
            autoFit: true,
            height: 340,
            padding:[40,60,80,60]
            });
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            });

            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });
            chart
            .line()
            .position('data*val')
            .color('name',["#44D7B6","#B620E0","#3F51B5","#5677FC","#FF944C"])
            .shape('smooth');
            // chart
            // .point()
            // .position('data*val')
            // .color('name')
            // .shape('circle');

            chart.render();
        },
        init2(){
            let d1=[
                {data:"6.21",name:'小程序',val:1000},
                {data:"6.22",name:'小程序',val:200},
                {data:"6.23",name:'小程序',val:300},
                {data:"6.24",name:'小程序',val:400},
            ]
            let d2=[
                {data:"6.21",name:'安卓端',val:200},
                {data:"6.22",name:'安卓端',val:400},
                {data:"6.23",name:'安卓端',val:100},
                {data:"6.24",name:'安卓端',val:200},
            ]
            let d3=[
                {data:"6.21",name:'iOS端',val:200},
                {data:"6.22",name:'iOS端',val:300},
                {data:"6.23",name:'iOS端',val:400},
                {data:"6.24",name:'iOS端',val:500},
            ]
            let d4=[
                {data:"6.21",name:'抖音',val:300},
                {data:"6.22",name:'抖音',val:200},
                {data:"6.23",name:'抖音',val:800},
                {data:"6.24",name:'抖音',val:200},
            ]
            let d5=[
                {data:"6.21",name:'小红书',val:300},
                {data:"6.22",name:'小红书',val:400},
                {data:"6.23",name:'小红书',val:200},
                {data:"6.24",name:'小红书',val:100},
            ]
            let data=[...d1,...d2,...d3,...d4,...d5];

            const chart = new this.$chart({
            container: 'Drain',
            autoFit: true,
            height: 340,
            padding:[40,60,80,60]
            });
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            });

            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });
            chart
            .line()
            .position('data*val')
            .color('name',["#44D7B6","#B620E0","#3F51B5","#5677FC","#FF944C"])
            .shape('smooth');
            // chart
            // .point()
            // .position('data*val')
            // .color('name')
            // .shape('circle');

            chart.render();
        },
    },
}
</script>
<style lang="less" scoped>
    
    .assistant{
         .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 9%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 14px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
        }
        .f2{
            .tit{
                display: flex;
                padding:15px 0;
                font-size: 16px;
                font-weight: 500;
                color: #333940;
                img{
                    margin-right:10px;
                    width:31px;
                    height:31px;
                }
            }
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    width:32%;
                    padding:30px;
                    border-radius: 8px;
                    box-sizing: border-box;
                    background: #fff;
                    p{
                        span{
                            display: inline-block;
                            padding:10px 15px;
                            background: linear-gradient(124deg, #1AA7F1 0%, #3F76FE 100%, #3F76FE 100%);
                            color:#fff;
                            border-radius: 20px;
                        }
                        &:nth-child(2){
                            height:60px;
                            padding:20px 0;
                            padding-bottom:10px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #666666;
                        }
                        &:last-child{
                            text-align: right;
                            .el-button{
                                font-size:12px;
                            }
                        }
                    }
                }
            }
        }
        .f3{
            .title{
                padding:30px 0;
            }
            ul{
                // display: flex;
                // justify-content: space-between;
                li{
                    display: inline-block;
                    margin-right:1%;
                    margin-bottom:15px;
                    width:24%;
                    background: #fff;
                    border-radius: 8px;
                    box-sizing: border-box;
                    div{
                        &:first-child{
                            padding:30px;
                            padding-bottom:15px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                img{
                                        margin-right: 15px;
                                        width:68px;
                                        height:68px;
                                        vertical-align: middle;
                                    }
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #333333;
                            }
                            img{
                                width:48px;
                                height:48px;
                            }  
                        }

                        &:nth-child(2){
                            padding:0 30px;
                            height:80px;
                            // margin-bottom:30px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #777777;
                            span{
                                font-size:16px;
                                color:#3C3939;
                            }
                        }
                        &:nth-child(3){
                            display: flex;
                            justify-content: space-between;
                            border-top:1px solid #ededed;
                            p{
                                padding:15px  0px;
                                width:33.3%;
                                border-right: 1px solid #ededed;
                                text-align: center;
                                font-size: 12px;
                                font-weight: 400;
                                color: #3C3939;
                                &:last-child{
                                    border-right: 0;
                                }
                            }
                        }
                        
                    }
                    .btn1{
                        border:0 !important;
                        display: flex;
                        padding:6px 30px;
                        justify-content: flex-end !important;
                        .el-button{
                            font-size:12px;
                            font-weight: 400;
                        }
                    }
                    .btn2{
                        p{
                            width:50% !important;
                        }
                    }
                    &:nth-child(4n){
                        margin:0;
                    }
                }
            }
        }
        .f4{
            margin-bottom:30px;
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    width:49%;
                    box-sizing: border-box;
                    background: #fff;
                    padding:30px;
                    border-radius: 8px;
                    .title{
                        margin-bottom:15px;
                    }
                    .text{
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        span{
                            font-size:14px;
                            color:#333;
                        }
                    }
                    &:last-child{
                        position: relative;
                        .posi{
                            position: absolute;
                            top:0;
                            right:0;
                            background: #327EFF;
                            width: 98px;
                            height: 36px;
                            text-align: center;
                            line-height: 36px;
                            background: #327EFF;
                            border-radius: 0px 6px 0px 18px;
                            img{
                                width:16px;
                                height:16px;
                                vertical-align: middle;
                            }
                            font-size: 14px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                    .cans{
                        margin-top:30px;

                        // display: flex;
                        // justify-content: space-between;
                        div{
                            margin-right:1%;
                            margin-bottom:30px;
                            display: inline-block;
                            width:24%;
                            p{
                                font-size: 20px;
                                font-family: DINAlternate-Bold, DINAlternate;
                                font-weight: bold;
                                color: #327EFF;
                                &:last-child{
                                    margin-top:10px;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                }
                            }
                        }
                    }
                    .num{
                        display: flex;
                        justify-content: space-between;
                        div{
                            &:first-child{
                                .t{
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: #327EFF;
                                }
                                .c{
                                    display: flex;
                                    div{
                                        &:first-child{
                                            p{
                                                font-size: 43px;
                                                font-weight: bold;
                                                color: #327EFF;
                                                span{
                                                    font-size:14px;
                                                    font-weight: 500;
                                                }
                                            }
                                        }
                                        &:last-child{
                                            p{
                                                &:first-child{
                                                    margin-bottom:6px;
                                                }
                                            }
                                            margin-left:15px;
                                            display: flex;
                                            flex-direction: column;
                                            justify-content: center;
                                            font-size: 12px;
                                            font-weight: 400;
                                            color: #7E858C;
                                        }
                                    }
                                }
                            }
                            
                        }
                        .number{
                            display: flex;
                            align-items: center;
                            i{
                                margin-top:10px;
                                margin-right:15px;
                                display: inline-block;
                                height:40px;
                                width:1px;
                                background: #333;
                            }
                            p{
                                font-size: 12px;
                                font-weight: 400;
                                color: #333333;
                                span{
                                    font-size:28px;
                                    color:#333;
                                    font-weight: bold;
                                }
                            }
                        }
                    }
                }
            }
        }
        .f5{
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    width:49%;
                    padding:30px;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 8px;
                    .content{
                        margin-top:30px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        div{
                            width:49%;
                            margin-left: -36px;
                            ul{
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                width: 200px;
                            }
                            &:first-child{
                                li{
                                    display: flex;
                                    align-items: center;
                                    position: relative;
                                    width:100%;
                                    padding:0;
                                    background: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
                                    div{
                                        margin: 0 auto;
                                        margin-top: -90px;
                                    }
                                    img{
                                        width:26px;
                                        height:26px;
                                    }
                                    p{
                                        text-align: center;
                                        font-size: 14px;
                                        font-weight: 500;
                                        color: #FFFFFF;
                                    }
                                    &:first-child{
                                        
                                        border-top: 90px solid ;
                                        // border-top-color: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
                                        border-top-color:#7898FF;
                                        border-left: 10px solid transparent;
                                        border-right: 10px solid transparent;
                                        height: 0;
                                       width: 160px;
                                        border-radius: 0;
                                    }
                                    &:nth-child(2){
                                        border-top: 90px solid ;
                                        // border-top-color: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
                                        border-top-color:#61E6DF;
                                        border-left: 10px solid transparent;
                                        border-right: 10px solid transparent;
                                        height: 0;
                                        width: 140px;
                                        border-radius: 0;
                                    }
                                    &:nth-child(3){
                                        border-top: 90px solid ;
                                        // border-top-color: linear-gradient(180deg, #7898FF 0%, #5E83F8 100%);
                                        border-top-color:#FF925F;
                                        border-left: 10px solid transparent;
                                        border-right: 10px solid transparent;
                                        height: 0;
                                        width: 120px;
                                        border-radius: 0;
                                    }
                                }
                            }
                            &:last-child{
                                // margin-left:-40px;
                                /deep/ .el-table{
                                    margin-left: 42px;
                                    // margin:0 auto;
                                }
                                .ts{
                                    margin-left: 42px;
                                    text-align: left; 
                                }
                                p{
                                    i{
                                        display: inline-block;
                                        width: 5px;
                                        height: 5px;
                                        background: #333333;
                                        border-radius: 50%;
                                    }
                                    //  margin-left: 42px;
                                    margin-top:10px;
                                    text-align: center;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    span{
                                        color:#333333;

                                    }
                                }
                            }
                        }

                    }
                }
                .l2{
                    padding:0;
                    .title{
                        padding:15px;
                    }
                    .ft{
                        margin:15px 0;
                        margin-left: 25px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        span{
                            color:#333333;
                            font-size:14px;
                        }
                    }

                }
            }
            .img-log{
                width:100% !important;
                display: flex;
                align-items: center;
                position: relative;
                span{
                    margin-left: 15px;
                    display: inline-block;
                    font-size: 10px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #666666;
                }
            }
            .log1,.log2{
                position: absolute;
                img{
                    width:28px;
                    height:68px;
                }
                span{
                    width: 55px;
                }
            }
            .log1{
               right: -128px;
                top: 61px;
            }
            .log2{
                right: -123px;
                top: 163px;
            }
            .log3{
                position: absolute;
                right: -118px;
                top: 26px;
                img{
                    width:112px;
                    height:223px;
                }
                span{
                    width: 60px;
                }
                
            }
        }
        .f6{
            margin-top:30px;
            ul{
                margin-top:15px;
                // display: flex;
                overflow-x:scroll;
                overflow-y:hidden;
                 white-space:nowrap;
                li{
                    display: inline-block;
                   
                    margin-right:20px;
                    width:320px;
                    background: #FFFFFF;
                    border-radius: 6px;
                }
                li{
                    .d1{
                        padding:15px;
                        div{
                            margin-bottom:10px;
                            display: flex;
                            justify-content: space-between;
                            &:first-child{
                                margin-bottom:10px;
                                img{
                                    width:16px;
                                }
                               
                                span{
                                    &:first-of-type{
                                        width:140px;
                                    }
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: rgba(37, 49, 62, 0.85);
                                }
                                .b{
                                    background: rgba(255, 174, 119, 0.3);
                                    border-radius: 13px;
                                    padding:4px 15px;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #FF812D;
                                }
                            }
                            .jdt{
                              align-items: center;
                            }
                             /deep/ .el-progress{
                                   width:72% !important; 
                                   margin: 0;
                                    margin-top: 10px;
                               }
                            /deep/ .el-progress__text{
                                color:#327EFF;
                                font-size:12px !important;
                                font-weight: 500;
                            }
                            span{
                                
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 500;
                                color: #999999;
                                &:first-child{
                                    display: inline-block;
                                    width:80px;
                                    text-align: right;
                                }
                            }
                        }
                        
                    }
                    .d2{
                        display: flex;
                        p{
                            padding:15px 0;
                            border-top:1px solid #ededed;
                            border-right:1px solid #ededed;
                            width:50%;
                            text-align: center;
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #3285F8;
                            img{
                                width:16px;
                                height:16px;
                                vertical-align: middle;
                            }
                            &:last-child{
                                border-right:0;
                            }
                        }
                    }
                }
            }
        }
        .title{
            // margin-bottom:30px;
            .t1{
                display: flex;
                justify-content: space-between;
                p{
                    .log{
                        width:20px;
                    }
                    img{
                        width:16px;
                        vertical-align: middle;
                        margin-right:10px;
                    }
                    /deep/ .el-input .el-input__inner{
                        background: #F6F6F9;
                        border:0px;
                    }
                    span{
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
            .t2{
                margin-top:12px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
            }
        }
        .f7{
            margin-top:30px;
            ul{
                
                display: flex;
                justify-content: space-between;
                li{
                    .title{
                        padding:20px 30px;
                    }
                    box-sizing: border-box;
                    border-radius: 8px;
                    background: #fff;
                    width:49%;
                }
                .l2{
                    .title{
                        // padding:30px;
                        // padding-top:30px;
                    }        
                }
                .ft{
                    padding:0 30px ;
                    font-size: 12px;
                    font-weight: 500;
                    color: #666666;
                    span{
                        color:#333;
                        font-size:14px;
                    }
                }
                .cont{
                    
                    padding:30px;
                    
                    .txt{
                        display: flex;
                        justify-content: space-between;
                        
                        span{
                            display:block;
                            &:first-of-type{
                                padding-bottom:10px;
                                font-size: 20px;
                                font-weight: bold;
                                color: #327EFF;
                            }
                            &:last-child{
                                font-size: 12px;
                                font-weight: 400;
                                color: #666666;
                            }
                        }
                    }
                }
                
            }
        }
    }
    .red{
        color:red !important;
    }
    .b5{
        background:#55DFD7 !important;
        color:#26C2B8 !important;
    }
    .c3{
        color:#333 !important;
    }
    .c0091FF{
        color:#0091FF !important;
    }
    .mb-30{
        margin-bottom:30px;
    }
    .mb-15{
        margin-bottom:15px;
    }
    .gru{
        color:#19E9AA !important;
    }
    @media screen and (min-width: 1200px) and (max-width: 1366px){
        .assistant .f5 ul li .content div ul{
            width:170px ;
        }
        .assistant .f5 ul li .content div:first-child li:first-child{
            width:140px ;
        }
        .assistant .f5 ul li .content div:first-child li:nth-child(2){
            width:120px ;
        }
        .assistant .f5 ul li .content div:first-child li:nth-child(3){
            width:100px ;
        }
        .assistant .f5 .log3{
            right: -91px ;
        }
        .assistant .f5 .log2{
            right: -94px;
        }
        .assistant .f5 .log1{
            right: -105px;
        }
        .assistant .f5 .img-log span{
            margin-left: 8px;
        }
    }
</style>